import React from 'react';
import '../css/OurFleet.css'; 
import { Helmet } from 'react-helmet';
import GoogleAnalytics from '../components/GoogleAnalytics';

const fleetItems = [
    {
      name: 'Swift Dzire',
      image: '/images/ourfleet/1.jpg',
      description: 'The Swift Dzire is a comfortable and efficient sedan, perfect for small groups or individuals looking for a smooth ride. It offers great fuel efficiency, a spacious interior and reliable performance for city and highway drives.',
      capacity: 'Up to 4+1 passengers',
      link: 'fleet-details/sedan.html'
    },
    {
      name: 'Honda City',
      image: '/images/ourfleet/2.jpg',
      description: 'The Honda City is a spacious and reliable sedan, offering a comfortable ride for both short city drives and longer journeys. Known for its reliability and premium feel, it makes every journey enjoyable.',
      capacity: 'Up to 4+1 passengers',
      link: 'fleet-details/van.html'
    },
    {
      name: 'Nexa Ciaz',
      image: '/images/ourfleet/4.jpg',
      description: 'Experience luxury and comfort with the Nexa Ciaz, a stylish sedan that combines premium features and a smooth driving experience. Ideal for those seeking comfort and elegance in their travel.',
      capacity: 'Up to 4+1 passengers',
      link: 'fleet-details/luxury-car.html'
    },
    {
      name: 'Ertiga',
      image: '/images/ourfleet/3.jpg',
      description: 'The Ertiga is a spacious MPV, designed to offer comfort and flexibility for families and groups. With its generous seating capacity and roomy interiors, it’s the perfect vehicle for road trips and group outings',
      capacity: 'Up to 7+1 passengers',
      link: 'fleet-details/mini-bus.html'
    },
    {
      name: 'Innova',
      image: '/images/ourfleet/5.jpg',
      description: 'The Innova is a spacious and efficient car, ideal for navigating through city streets while offering a comfortable ride. Known for its durability and high performance, it’s perfect for family travels.',
      capacity: 'Up to 7+1 passengers',
      link: 'fleet-details/hatchback.html'
    },
    {
      name: 'Innova Crysta',
      image: '/images/ourfleet/6.jpg',
      description: 'Drive in style and comfort with the Innova Crysta. Equipped with modern features, advanced safety and a smooth driving experience, it’s perfect for both short trips and long-distance travel adventures.',
      capacity: 'Up to 7+1 passengers',
      link: 'fleet-details/electric-car.html'
    },
    {
      name: 'Fortuner',
      image: '/images/ourfleet/7.jpg',
      description: 'The Fortuner is a stylish and powerful SUV, perfect for adventurous drives and offering ample space for up to 8 passengers. Ideal for rugged terrains and luxurious long journeys.',
      capacity: 'Up to 8+1 passengers',
      link: 'fleet-details/convertible.html'
    },
    {
      name: 'Audi',
      image: '/images/ourfleet/8.jpg',
      description: 'The Audi motorhome is the perfect companion for long road trips, offering both comfort and luxury for extended stays on the road. Luxury redefined for your travel experience.',
      capacity: 'Up to 4+1 passengers',
      link: 'fleet-details/motorhome.html'
    },
    {
      name: 'BMW',
      image: '/images/ourfleet/9.jpg',
      description: 'The BMW limousine exudes luxury and sophistication, making it the ideal choice for special events or elegant occasions. Enjoy the smooth ride and premium comfort.',
      capacity: 'Up to 8+1 passengers',
      link: 'fleet-details/limousine.html'
    },
    {
      name: 'Jaguar',
      image: '/images/ourfleet/10.jpg',
      description: 'Step into luxury with the Jaguar designed for comfort and elegance. Perfect for those seeking sophistication, smoothness and a memorable experience.',
      capacity: 'Up to 8+1 passengers',
      link: 'fleet-details/limousine.html'
    },
    {
      name: 'Tata Winger',
      image: '/images/ourfleet/11.jpg',
      description: 'The Tata Winger is a versatile crossover vehicle that performs well on both city streets and highways, providing comfort for long or short trips. A perfect choice for group outings and adventures.',
      capacity: 'Up to 13/17 passengers',
      link: 'fleet-details/crossover.html'
    },
    {
      name: '13 Seater Tempo Traveller',
      image: '/images/ourfleet/12.jpg',
      description: 'The 13 Seater Tempo Traveller is designed for larger groups, offering plenty of space and comfort for group travel. Ideal for family reunions, corporate trips, or group tours.',
      capacity: 'Up to 13 passengers',
      link: 'fleet-details/motorcycle.html'
    },
    {
      name: '17 Seater Tempo Traveller',
      image: '/images/ourfleet/13.jpg',
      description: 'The 17 Seater Tempo Traveller is ideal for larger groups, providing a spacious and comfortable experience for all passengers. Perfect for big family gatherings and group events.',
      capacity: 'Up to 17 passengers',
      link: 'fleet-details/coach-bus.html'
    },
    {
      name: '20 Seater Tempo Traveller',
      image: '/images/ourfleet/14.jpg',
      description: 'The 20 Seater Tempo Traveller is perfect for large groups, offering ample space and comfort for both short and long-distance travel. A great option for corporate and tourist group trips.',
      capacity: 'Up to 20 passengers',
      link: 'fleet-details/taxi.html'
    },
    {
      name: 'Luxury Bus',
      image: '/images/ourfleet/15.jpg',
      description: 'The Luxury Bus offers a smooth ride for large groups with its spacious interior and premium features. Perfect for corporate events, family tours and group travel.',
      capacity: 'Up to 32 passengers',
      link: 'fleet-details/jeep.html'
    }
  ];
  



const OurFleet = () => {
    return (
        <div>
        <GoogleAnalytics/>
<section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero1.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">Our Fleet </h1>
          </div>
        </div>
      </section>

          

            <section className="our-fleet-section " style={{backgroundColor :'#FFFFFF'}}>
                <div className="auto-container container">
                    <div className="sec-title text-center">
                    </div>
                    <div className="row">
                        {fleetItems.map((item, index) => (
                            <div className="fleet-block col-lg-4 col-md-6 col-sm-12 py-4" key={index}>
                                <div className="inner-box">
                                    <figure className="image borderr">
                                        <a>
                                            <img src={item.image} alt={item.name} />
                                        </a>
                                    </figure>
                                    <div className="content">
                                        <h4 className="title">
                                            <a>{item.name}</a>
                                        </h4>
                                        <div className="text text-white">{item.description}</div>
                                        {/* <div className="capacity">Capacity: {item.capacity}</div> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OurFleet;
